import { render } from "./LineConfigurationsEditorLine.vue?vue&type=template&id=1f89edfb&scoped=true&ts=true"
import script from "./LineConfigurationsEditorLine.vue?vue&type=script&lang=ts"
export * from "./LineConfigurationsEditorLine.vue?vue&type=script&lang=ts"

import "./LineConfigurationsEditorLine.vue?vue&type=style&index=0&id=1f89edfb&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/apps/builder-legacy/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f89edfb"]])

export default __exports__